import locale from '@glu/locale';
import { withStyles } from '@glu/theming';
import { AccessibilityText } from '@glu/utilities-react';
import PropTypes from 'prop-types';
import React from 'react';

import '../../themeDefaults';

import styles from './Loading.styles';

const Loading = ({
  isLoading, children, classes, className, size, theme, ...rest
}) => (isLoading ? (
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  <div className={`${classes.root} ${className}`.trim()} {...rest}>
    <AccessibilityText>{locale.get('loading')}</AccessibilityText>
  </div>
) : children);

Loading.propTypes = {
  /** @type {boolean} - If true, shows loading indicator, else shows children */
  isLoading: PropTypes.bool.isRequired,

  /** Children to show when loading is finished */
  children: PropTypes.node.isRequired,

  /** @type {Object} - Internal JSS classes */
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  theme: PropTypes.shape({}),

  /** @type [string] - CSS class for the root element */
  className: PropTypes.string,

  /** @type [number|string] - Height and width of loading indicator (overrides theme) */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Loading.defaultProps = {
  className: undefined,
  size: undefined,
  theme: undefined
};

export const BareLoading = Loading;
const ThemedLoading = withStyles(styles)(Loading);
ThemedLoading.displayName = 'Loading';
export default ThemedLoading;
